export const getErrorMessage = (
  error,
  fallback = 'Ocurrió un error inesperado.'
) => error?.response?.data?.message || error?.message || fallback;
